import React, { useEffect, useState } from 'react'
import { Button, Col, Row } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

//Components
import TextField from '../../../components/TextField/TextField';
import MainCard from '../../../components/MainCard/MainCard';

//Helpers
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';
import mascaras from '../../../helpers/mascaras';
import { showMessage } from '../../../helpers/message';

//Context
import { useAuth } from '../../../context/auth';

//API
import tipoAutoInfracao_api from '../../../api/tipoAutoInfracao_api';

//Estado inicial da prefeitura
function initialStateAutoInfracao() {
    return {
        transportador: "false",
        destino: "false", 
        gerador: "false", 
        fatoConstitutivo: "", 
        preceitosLegais: "",
        valorMulta: "0",
        status: "Ativo"
    }
}

export default function NovaAutoInfracao({ id,  btnVoltar }) {
    const { setLoading } = useAuth();

    //Estado que guarda os dados do auto de infração a ser Adicionada/Editada
    const [autoDeInfracao, setAutoDeInfracao] = useState(initialStateAutoInfracao());
    
    //Estado que guarda os erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Campos obrigatorios do cadastro
    const campos = [
        objCampo({ name: "fatoConstitutivo", required: true }),
        objCampo({ name: "preceitosLegais", required: true }),
        objCampo({ name: "valorMulta", required: true, number: true }),
        objCampo({ name: "status", required: true }),
    ];

    const onChange = (e) => {
        const { name, value } = e.target;

        const _autoInfracao = {
            ...autoDeInfracao,
            [name]: value
        }
        const erros = validarCampos(_autoInfracao, campos.filter(c => c.name == name));
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        }

        setAutoDeInfracao(_autoInfracao)
    }
    
    async function onSubmit() {
       const erros = validarCampos(autoDeInfracao, campos);
        setErrors(erros[0]);
        if (erros[1].length > 0) {
            return;
        }

        const _autoInfracao = {...autoDeInfracao};
        _autoInfracao.valorMulta = _autoInfracao.valorMulta.replace(",", ".");

        if(_autoInfracao.id){
            try {
                setLoading(true);
                await tipoAutoInfracao_api.Update(_autoInfracao);
                showMessage("Sucesso", "Sucesso ao editar o auto da infração", "success", () => {
                    setLoading(false);
                    btnVoltar();
                });
            }catch(ex) {
                showMessage("Error", ex.message, "error", null);
            }finally {
                setLoading(false);
            }
        }else {
            try {
                setLoading(true);
                await tipoAutoInfracao_api.Insert(_autoInfracao);
                showMessage("Sucesso", "Sucesso ao cadastrar o auto da infração", "success", () => {
                    setLoading(false);
                    btnVoltar();
                });
            }catch(ex) {
                showMessage("Error", ex.message, "error", null);
            }finally {
                setLoading(false);
            }
        }
    }

    async function loadItem(id) {
       try {
           setLoading(true);
           const { data } = await tipoAutoInfracao_api.GetItem(id);
            console.log( data.valorMulta )
           setAutoDeInfracao({
            ...data,
            transportador: data.transportador ? "true" : "false",
            destino: data.destino ? "true" : "false", 
            gerador: data.gerador ? "true" : "false", 
            valorMulta: data.valorMulta.toFixed(2)
           });
       }catch(ex) {
            showMessage("Error", ex.message, "error", null);
       }finally {
            setLoading(false);
       }
    }

    useEffect(() => {
        if (id) loadItem(id);
    }, []);

    console.log(id)

  return (
     <MainCard btnVoltar={btnVoltar}>
            <Row className='mb-4'>
                <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
            </Row>
            <Row>
                <Col lg={2}>
                    <TextField
                        invalid={!!errors.destino}
                        label={"* Destino"}
                        name="destino" 
                        type={"select"}
                        options={[ 
                            { text: "Sim", value: "true" },
                            { text: "Não", value: "false" },
                        ]}
                        value={autoDeInfracao.destino}
                        onChange={onChange}
                    />
                </Col>
                <Col lg={2}>
                    <TextField
                        invalid={!!errors.gerador}
                        label={"* Gerador"}
                        name="gerador" 
                        type={"select"}
                        options={[ 
                            { text: "Sim", value: "true" },
                            { text: "Não", value: "false" },
                        ]}
                        value={autoDeInfracao.gerador}
                        onChange={onChange}
                    />
                </Col>
                <Col lg={2}>
                    <TextField
                        invalid={!!errors.transportador}
                        label={"* Transportador"}
                        name="transportador" 
                        type={"select"}
                        options={[ 
                            { text: "Sim", value: "true" },
                            { text: "Não", value: "false" },
                        ]}
                        value={autoDeInfracao.transportador}
                        onChange={onChange}
                    />
                </Col>
                <Col lg={3}>
                    <TextField
                        invalid={!!errors.status}
                        label={"* Status"}
                        name="status" 
                        type={"select"}
                        options={[ 
                            { text: "Ativo", value: "Ativo" },
                            { text: "Inativo", value: "Inativo" },
                        ]}
                        value={autoDeInfracao.status}
                        onChange={onChange}
                    />
                </Col>
                <Col lg={3}>
                    <TextField
                        invalid={!!errors.valorMulta}
                        label={"* Valor multa (R$)"}
                        name="valorMulta"   
                        mask={mascaras.floatMask}
                        value={autoDeInfracao.valorMulta}
                        onChange={onChange}
                    />
                </Col>
                <Col lg={12}>
                    <TextField
                        invalid={!!errors.fatoConstitutivo}
                        label={"* Fato constitutivo"}
                        type={"textarea"}
                        name="fatoConstitutivo"
                        value={autoDeInfracao.fatoConstitutivo}
                        onChange={onChange}
                        maxLength={300}
                    />
                </Col>
                <Col lg={12}>
                    <TextField
                        invalid={!!errors.preceitosLegais}
                        label={"* Preceitos legais"}
                        type={"textarea"}
                        name="preceitosLegais"
                        value={autoDeInfracao.preceitosLegais}
                        onChange={onChange}
                        maxLength={300}
                    />
                </Col>
                <div className='mt-4 d-flex align-items-center justify-content-center'>
                    <Button 
                        className='bg-gradient' 
                        color={id ? 'warning text-light' : 'success'} 
                        onClick={onSubmit}>
                            {id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : <>+ Adicionar</>}
                    </Button>
                </div>
            </Row> 
        </MainCard>
  )
}
